// Auto-generated icon imports - do not edit manually
import ic_add from './svg/ic_add.svg';
import ic_add_circle from './svg/ic_add_circle.svg';
import ic_add_circle_filled from './svg/ic_add_circle_filled.svg';
import ic_add_image from './svg/ic_add_image.svg';
import ic_add_image_filled from './svg/ic_add_image_filled.svg';
import ic_add_reaction from './svg/ic_add_reaction.svg';
import ic_alert_triangle from './svg/ic_alert_triangle.svg';
import ic_alert_triangle_filled from './svg/ic_alert_triangle_filled.svg';
import ic_arrow_diagonal_bottom_left from './svg/ic_arrow_diagonal_bottom_left.svg';
import ic_arrow_diagonal_bottom_right from './svg/ic_arrow_diagonal_bottom_right.svg';
import ic_arrow_diagonal_top_left from './svg/ic_arrow_diagonal_top_left.svg';
import ic_arrow_diagonal_top_right from './svg/ic_arrow_diagonal_top_right.svg';
import ic_arrow_down from './svg/ic_arrow_down.svg';
import ic_arrow_down_left from './svg/ic_arrow_down_left.svg';
import ic_arrow_down_right from './svg/ic_arrow_down_right.svg';
import ic_arrow_left from './svg/ic_arrow_left.svg';
import ic_arrow_left_down from './svg/ic_arrow_left_down.svg';
import ic_arrow_left_up from './svg/ic_arrow_left_up.svg';
import ic_arrow_redo from './svg/ic_arrow_redo.svg';
import ic_arrow_right from './svg/ic_arrow_right.svg';
import ic_arrow_right_down from './svg/ic_arrow_right_down.svg';
import ic_arrow_right_up from './svg/ic_arrow_right_up.svg';
import ic_arrow_undo from './svg/ic_arrow_undo.svg';
import ic_arrow_up from './svg/ic_arrow_up.svg';
import ic_arrow_up_left from './svg/ic_arrow_up_left.svg';
import ic_arrow_up_right from './svg/ic_arrow_up_right.svg';
import ic_arrows_expand from './svg/ic_arrows_expand.svg';
import ic_arrows_full_screen from './svg/ic_arrows_full_screen.svg';
import ic_arrows_input from './svg/ic_arrows_input.svg';
import ic_arrows_right_left from './svg/ic_arrows_right_left.svg';
import ic_atm from './svg/ic_atm.svg';
import ic_atm_filled from './svg/ic_atm_filled.svg';
import ic_atm_text from './svg/ic_atm_text.svg';
import ic_attachment from './svg/ic_attachment.svg';
import ic_balloon from './svg/ic_balloon.svg';
import ic_balloon_filled from './svg/ic_balloon_filled.svg';
import ic_bank from './svg/ic_bank.svg';
import ic_baseball from './svg/ic_baseball.svg';
import ic_baseball_filled from './svg/ic_baseball_filled.svg';
import ic_basketball from './svg/ic_basketball.svg';
import ic_basketball_filled from './svg/ic_basketball_filled.svg';
import ic_battery_empty from './svg/ic_battery_empty.svg';
import ic_battery_full from './svg/ic_battery_full.svg';
import ic_battery_half from './svg/ic_battery_half.svg';
import ic_battery_high from './svg/ic_battery_high.svg';
import ic_battery_low from './svg/ic_battery_low.svg';
import ic_bear from './svg/ic_bear.svg';
import ic_bear_filled from './svg/ic_bear_filled.svg';
import ic_bell from './svg/ic_bell.svg';
import ic_bell_filled from './svg/ic_bell_filled.svg';
import ic_bike from './svg/ic_bike.svg';
import ic_bluetooth from './svg/ic_bluetooth.svg';
import ic_boat from './svg/ic_boat.svg';
import ic_boat_filled from './svg/ic_boat_filled.svg';
import ic_book from './svg/ic_book.svg';
import ic_book_2 from './svg/ic_book_2.svg';
import ic_book_2_filled from './svg/ic_book_2_filled.svg';
import ic_book_filled from './svg/ic_book_filled.svg';
import ic_bookmark from './svg/ic_bookmark.svg';
import ic_bookmark_filled from './svg/ic_bookmark_filled.svg';
import ic_bull from './svg/ic_bull.svg';
import ic_bull_filled from './svg/ic_bull_filled.svg';
import ic_burger from './svg/ic_burger.svg';
import ic_burger_filled from './svg/ic_burger_filled.svg';
import ic_bus from './svg/ic_bus.svg';
import ic_bus_filled from './svg/ic_bus_filled.svg';
import ic_cake from './svg/ic_cake.svg';
import ic_cake_filled from './svg/ic_cake_filled.svg';
import ic_calendar from './svg/ic_calendar.svg';
import ic_calendar_check from './svg/ic_calendar_check.svg';
import ic_calendar_check_filled from './svg/ic_calendar_check_filled.svg';
import ic_calendar_filled from './svg/ic_calendar_filled.svg';
import ic_camera from './svg/ic_camera.svg';
import ic_camera_filled from './svg/ic_camera_filled.svg';
import ic_car from './svg/ic_car.svg';
import ic_car_filled from './svg/ic_car_filled.svg';
import ic_card from './svg/ic_card.svg';
import ic_card_filled from './svg/ic_card_filled.svg';
import ic_cart from './svg/ic_cart.svg';
import ic_cart_filled from './svg/ic_cart_filled.svg';
import ic_cash_back from './svg/ic_cash_back.svg';
import ic_celebrate from './svg/ic_celebrate.svg';
import ic_celebrate_filled from './svg/ic_celebrate_filled.svg';
import ic_cent_sign from './svg/ic_cent_sign.svg';
import ic_check from './svg/ic_check.svg';
import ic_check_badge from './svg/ic_check_badge.svg';
import ic_check_badge_filled from './svg/ic_check_badge_filled.svg';
import ic_check_circle from './svg/ic_check_circle.svg';
import ic_check_circle_filled from './svg/ic_check_circle_filled.svg';
import ic_check_filled from './svg/ic_check_filled.svg';
import ic_check_image from './svg/ic_check_image.svg';
import ic_check_image_filled from './svg/ic_check_image_filled.svg';
import ic_check_shield from './svg/ic_check_shield.svg';
import ic_check_shield_filled from './svg/ic_check_shield_filled.svg';
import ic_checklist from './svg/ic_checklist.svg';
import ic_chevron from './svg/ic_chevron.svg';
import ic_chevron_down from './svg/ic_chevron_down.svg';
import ic_chevron_down_circle from './svg/ic_chevron_down_circle.svg';
import ic_chevron_down_circle_filled from './svg/ic_chevron_down_circle_filled.svg';
import ic_chevron_green_left from './svg/ic_chevron_green_left.svg';
import ic_chevron_left from './svg/ic_chevron_left.svg';
import ic_chevron_left_circle from './svg/ic_chevron_left_circle.svg';
import ic_chevron_left_circle_filled from './svg/ic_chevron_left_circle_filled.svg';
import ic_chevron_right from './svg/ic_chevron_right.svg';
import ic_chevron_right_circle from './svg/ic_chevron_right_circle.svg';
import ic_chevron_right_circle_filled from './svg/ic_chevron_right_circle_filled.svg';
import ic_chevron_up from './svg/ic_chevron_up.svg';
import ic_chevron_up_circle from './svg/ic_chevron_up_circle.svg';
import ic_chevron_up_circle_filled from './svg/ic_chevron_up_circle_filled.svg';
import ic_circle_check from './svg/ic_circle_check.svg';
import ic_circle_check_filled from './svg/ic_circle_check_filled.svg';
import ic_circle_circle from './svg/ic_circle_circle.svg';
import ic_circle_circle_filled from './svg/ic_circle_circle_filled.svg';
import ic_circle_dollar from './svg/ic_circle_dollar.svg';
import ic_circle_dollar_filled from './svg/ic_circle_dollar_filled.svg';
import ic_circle_minus from './svg/ic_circle_minus.svg';
import ic_circle_minus_filled from './svg/ic_circle_minus_filled.svg';
import ic_circle_slash from './svg/ic_circle_slash.svg';
import ic_circle_smile from './svg/ic_circle_smile.svg';
import ic_circle_smile_filled from './svg/ic_circle_smile_filled.svg';
import ic_clock from './svg/ic_clock.svg';
import ic_clock_filled from './svg/ic_clock_filled.svg';
import ic_conversation from './svg/ic_conversation.svg';
import ic_conversation_filled from './svg/ic_conversation_filled.svg';
import ic_copy from './svg/ic_copy.svg';
import ic_copy_filled from './svg/ic_copy_filled.svg';
import ic_crash from './svg/ic_crash.svg';
import ic_crash_filled from './svg/ic_crash_filled.svg';
import ic_crown from './svg/ic_crown.svg';
import ic_crown_filled from './svg/ic_crown_filled.svg';
import ic_currency_dollar from './svg/ic_currency_dollar.svg';
import ic_currency_dollar_circle from './svg/ic_currency_dollar_circle.svg';
import ic_currency_dollar_circle_filled from './svg/ic_currency_dollar_circle_filled.svg';
import ic_currency_dollar_square from './svg/ic_currency_dollar_square.svg';
import ic_currency_dollar_square_filled from './svg/ic_currency_dollar_square_filled.svg';
import ic_currency_euro from './svg/ic_currency_euro.svg';
import ic_currency_pound from './svg/ic_currency_pound.svg';
import ic_currency_yen from './svg/ic_currency_yen.svg';
import ic_custom_card from './svg/ic_custom_card.svg';
import ic_custom_card_filled from './svg/ic_custom_card_filled.svg';
import ic_customer_service from './svg/ic_customer_service.svg';
import ic_debit_pin from './svg/ic_debit_pin.svg';
import ic_deposit_check from './svg/ic_deposit_check.svg';
import ic_deposit_check_filled from './svg/ic_deposit_check_filled.svg';
import ic_desktop from './svg/ic_desktop.svg';
import ic_diamond from './svg/ic_diamond.svg';
import ic_diamond_filled from './svg/ic_diamond_filled.svg';
import ic_directions from './svg/ic_directions.svg';
import ic_dollar_bill from './svg/ic_dollar_bill.svg';
import ic_dollar_bill_filled from './svg/ic_dollar_bill_filled.svg';
import ic_dot from './svg/ic_dot.svg';
import ic_download from './svg/ic_download.svg';
import ic_earth from './svg/ic_earth.svg';
import ic_ellipse from './svg/ic_ellipse.svg';
import ic_emergency from './svg/ic_emergency.svg';
import ic_emergency_filled from './svg/ic_emergency_filled.svg';
import ic_envelope from './svg/ic_envelope.svg';
import ic_envelope_filled from './svg/ic_envelope_filled.svg';
import ic_envelope_open from './svg/ic_envelope_open.svg';
import ic_envelope_open_filled from './svg/ic_envelope_open_filled.svg';
import ic_error_circle from './svg/ic_error_circle.svg';
import ic_error_circle_filled from './svg/ic_error_circle_filled.svg';
import ic_etf_placeholder from './svg/ic_etf_placeholder.svg';
import ic_external_link from './svg/ic_external_link.svg';
import ic_eye_hide from './svg/ic_eye_hide.svg';
import ic_eye_show from './svg/ic_eye_show.svg';
import ic_eye_show_filled from './svg/ic_eye_show_filled.svg';
import ic_face_id from './svg/ic_face_id.svg';
import ic_family from './svg/ic_family.svg';
import ic_family_filled from './svg/ic_family_filled.svg';
import ic_fast_forward from './svg/ic_fast_forward.svg';
import ic_fast_forward_filled from './svg/ic_fast_forward_filled.svg';
import ic_file from './svg/ic_file.svg';
import ic_file_filled from './svg/ic_file_filled.svg';
import ic_find_location from './svg/ic_find_location.svg';
import ic_find_location_filled from './svg/ic_find_location_filled.svg';
import ic_flag from './svg/ic_flag.svg';
import ic_flag_filled from './svg/ic_flag_filled.svg';
import ic_folder from './svg/ic_folder.svg';
import ic_folder_filled from './svg/ic_folder_filled.svg';
import ic_game_controller from './svg/ic_game_controller.svg';
import ic_game_controller_filled from './svg/ic_game_controller_filled.svg';
import ic_gaming from './svg/ic_gaming.svg';
import ic_gaming_filled from './svg/ic_gaming_filled.svg';
import ic_gas_station from './svg/ic_gas_station.svg';
import ic_gas_station_filled from './svg/ic_gas_station_filled.svg';
import ic_gift from './svg/ic_gift.svg';
import ic_gift_filled from './svg/ic_gift_filled.svg';
import ic_gl_square from './svg/ic_gl_square.svg';
import ic_graduation from './svg/ic_graduation.svg';
import ic_graduation_cap from './svg/ic_graduation_cap.svg';
import ic_graduation_filled from './svg/ic_graduation_filled.svg';
import ic_graph_bar from './svg/ic_graph_bar.svg';
import ic_graph_bar_filled from './svg/ic_graph_bar_filled.svg';
import ic_graph_pie from './svg/ic_graph_pie.svg';
import ic_graph_pie_filled from './svg/ic_graph_pie_filled.svg';
import ic_greenlight from './svg/ic_greenlight.svg';
import ic_grid from './svg/ic_grid.svg';
import ic_grid_filled from './svg/ic_grid_filled.svg';
import ic_hanger from './svg/ic_hanger.svg';
import ic_headphones from './svg/ic_headphones.svg';
import ic_headphones_filled from './svg/ic_headphones_filled.svg';
import ic_heart from './svg/ic_heart.svg';
import ic_heart_filled from './svg/ic_heart_filled.svg';
import ic_help from './svg/ic_help.svg';
import ic_help_circle from './svg/ic_help_circle.svg';
import ic_help_circle_filled from './svg/ic_help_circle_filled.svg';
import ic_help_square from './svg/ic_help_square.svg';
import ic_home from './svg/ic_home.svg';
import ic_home_filled from './svg/ic_home_filled.svg';
import ic_image from './svg/ic_image.svg';
import ic_image_filled from './svg/ic_image_filled.svg';
import ic_info_circle from './svg/ic_info_circle.svg';
import ic_info_circle_filled from './svg/ic_info_circle_filled.svg';
import ic_invest from './svg/ic_invest.svg';
import ic_invest_down from './svg/ic_invest_down.svg';
import ic_laptop from './svg/ic_laptop.svg';
import ic_leave from './svg/ic_leave.svg';
import ic_lifesaver from './svg/ic_lifesaver.svg';
import ic_lightbulb from './svg/ic_lightbulb.svg';
import ic_lightbulb_filled from './svg/ic_lightbulb_filled.svg';
import ic_lightning from './svg/ic_lightning.svg';
import ic_lightning_filled from './svg/ic_lightning_filled.svg';
import ic_link from './svg/ic_link.svg';
import ic_list from './svg/ic_list.svg';
import ic_loading from './svg/ic_loading.svg';
import ic_location from './svg/ic_location.svg';
import ic_location_filled from './svg/ic_location_filled.svg';
import ic_location_map from './svg/ic_location_map.svg';
import ic_location_map_filled from './svg/ic_location_map_filled.svg';
import ic_location_pin from './svg/ic_location_pin.svg';
import ic_location_pin_filled from './svg/ic_location_pin_filled.svg';
import ic_lock from './svg/ic_lock.svg';
import ic_lock_filled from './svg/ic_lock_filled.svg';
import ic_lock_unlocked from './svg/ic_lock_unlocked.svg';
import ic_lock_unlocked_filled from './svg/ic_lock_unlocked_filled.svg';
import ic_log_out from './svg/ic_log_out.svg';
import ic_logo_amazon from './svg/ic_logo_amazon.svg';
import ic_logo_android from './svg/ic_logo_android.svg';
import ic_logo_apple from './svg/ic_logo_apple.svg';
import ic_logo_bitcoin from './svg/ic_logo_bitcoin.svg';
import ic_logo_facebook from './svg/ic_logo_facebook.svg';
import ic_logo_google from './svg/ic_logo_google.svg';
import ic_logo_instagram from './svg/ic_logo_instagram.svg';
import ic_logo_linked_in from './svg/ic_logo_linked_in.svg';
import ic_logo_paypal from './svg/ic_logo_paypal.svg';
import ic_logo_tiktok from './svg/ic_logo_tiktok.svg';
import ic_logo_twitter from './svg/ic_logo_twitter.svg';
import ic_logo_venmo from './svg/ic_logo_venmo.svg';
import ic_logo_youtube from './svg/ic_logo_youtube.svg';
import ic_lunch from './svg/ic_lunch.svg';
import ic_map from './svg/ic_map.svg';
import ic_map_filled from './svg/ic_map_filled.svg';
import ic_menu from './svg/ic_menu.svg';
import ic_message from './svg/ic_message.svg';
import ic_message_alert from './svg/ic_message_alert.svg';
import ic_message_alert_filled from './svg/ic_message_alert_filled.svg';
import ic_message_filled from './svg/ic_message_filled.svg';
import ic_microphone from './svg/ic_microphone.svg';
import ic_microphone_filled from './svg/ic_microphone_filled.svg';
import ic_money_bag from './svg/ic_money_bag.svg';
import ic_money_bag_filled from './svg/ic_money_bag_filled.svg';
import ic_moon from './svg/ic_moon.svg';
import ic_moon_filled from './svg/ic_moon_filled.svg';
import ic_more from './svg/ic_more.svg';
import ic_number_0_circle from './svg/ic_number_0_circle.svg';
import ic_number_0_circle_filled from './svg/ic_number_0_circle_filled.svg';
import ic_number_0_square from './svg/ic_number_0_square.svg';
import ic_number_0_square_filled from './svg/ic_number_0_square_filled.svg';
import ic_number_1_circle from './svg/ic_number_1_circle.svg';
import ic_number_1_circle_filled from './svg/ic_number_1_circle_filled.svg';
import ic_number_1_square from './svg/ic_number_1_square.svg';
import ic_number_1_square_filled from './svg/ic_number_1_square_filled.svg';
import ic_number_2_circle from './svg/ic_number_2_circle.svg';
import ic_number_2_circle_filled from './svg/ic_number_2_circle_filled.svg';
import ic_number_2_square from './svg/ic_number_2_square.svg';
import ic_number_2_square_filled from './svg/ic_number_2_square_filled.svg';
import ic_number_3_circle from './svg/ic_number_3_circle.svg';
import ic_number_3_circle_filled from './svg/ic_number_3_circle_filled.svg';
import ic_number_3_square from './svg/ic_number_3_square.svg';
import ic_number_3_square_filled from './svg/ic_number_3_square_filled.svg';
import ic_number_4_circle from './svg/ic_number_4_circle.svg';
import ic_number_4_circle_filled from './svg/ic_number_4_circle_filled.svg';
import ic_number_4_square from './svg/ic_number_4_square.svg';
import ic_number_4_square_filled from './svg/ic_number_4_square_filled.svg';
import ic_number_5_circle from './svg/ic_number_5_circle.svg';
import ic_number_5_circle_filled from './svg/ic_number_5_circle_filled.svg';
import ic_number_5_square from './svg/ic_number_5_square.svg';
import ic_number_5_square_filled from './svg/ic_number_5_square_filled.svg';
import ic_number_6_circle from './svg/ic_number_6_circle.svg';
import ic_number_6_circle_filled from './svg/ic_number_6_circle_filled.svg';
import ic_number_6_square from './svg/ic_number_6_square.svg';
import ic_number_6_square_filled from './svg/ic_number_6_square_filled.svg';
import ic_number_7_circle from './svg/ic_number_7_circle.svg';
import ic_number_7_circle_filled from './svg/ic_number_7_circle_filled.svg';
import ic_number_7_square from './svg/ic_number_7_square.svg';
import ic_number_7_square_filled from './svg/ic_number_7_square_filled.svg';
import ic_number_8_circle from './svg/ic_number_8_circle.svg';
import ic_number_8_circle_filled from './svg/ic_number_8_circle_filled.svg';
import ic_number_8_square from './svg/ic_number_8_square.svg';
import ic_number_8_square_filled from './svg/ic_number_8_square_filled.svg';
import ic_number_9_circle from './svg/ic_number_9_circle.svg';
import ic_number_9_circle_filled from './svg/ic_number_9_circle_filled.svg';
import ic_number_9_square from './svg/ic_number_9_square.svg';
import ic_number_9_square_filled from './svg/ic_number_9_square_filled.svg';
import ic_number_one_circle_filled from './svg/ic_number_one_circle_filled.svg';
import ic_number_one_square from './svg/ic_number_one_square.svg';
import ic_number_two_circle_filled from './svg/ic_number_two_circle_filled.svg';
import ic_number_two_square from './svg/ic_number_two_square.svg';
import ic_odometer from './svg/ic_odometer.svg';
import ic_odometer_filled from './svg/ic_odometer_filled.svg';
import ic_options from './svg/ic_options.svg';
import ic_options_filled from './svg/ic_options_filled.svg';
import ic_pace from './svg/ic_pace.svg';
import ic_parent from './svg/ic_parent.svg';
import ic_parent_filled from './svg/ic_parent_filled.svg';
import ic_passenger from './svg/ic_passenger.svg';
import ic_pause from './svg/ic_pause.svg';
import ic_pause_filled from './svg/ic_pause_filled.svg';
import ic_paw from './svg/ic_paw.svg';
import ic_paw_filled from './svg/ic_paw_filled.svg';
import ic_pen from './svg/ic_pen.svg';
import ic_people from './svg/ic_people.svg';
import ic_people_filled from './svg/ic_people_filled.svg';
import ic_person from './svg/ic_person.svg';
import ic_person_add from './svg/ic_person_add.svg';
import ic_person_add_filled from './svg/ic_person_add_filled.svg';
import ic_person_check from './svg/ic_person_check.svg';
import ic_person_check_filled from './svg/ic_person_check_filled.svg';
import ic_person_filled from './svg/ic_person_filled.svg';
import ic_phone from './svg/ic_phone.svg';
import ic_phone_filled from './svg/ic_phone_filled.svg';
import ic_phone_mobile from './svg/ic_phone_mobile.svg';
import ic_piggy_bank from './svg/ic_piggy_bank.svg';
import ic_piggy_bank_filled from './svg/ic_piggy_bank_filled.svg';
import ic_plane from './svg/ic_plane.svg';
import ic_plane_filled from './svg/ic_plane_filled.svg';
import ic_play from './svg/ic_play.svg';
import ic_play_circle from './svg/ic_play_circle.svg';
import ic_play_circle_filled from './svg/ic_play_circle_filled.svg';
import ic_play_filled from './svg/ic_play_filled.svg';
import ic_plus from './svg/ic_plus.svg';
import ic_profile_circle from './svg/ic_profile_circle.svg';
import ic_profile_circle_filled from './svg/ic_profile_circle_filled.svg';
import ic_push_pin from './svg/ic_push_pin.svg';
import ic_push_pin_filled from './svg/ic_push_pin_filled.svg';
import ic_qr_code from './svg/ic_qr_code.svg';
import ic_question from './svg/ic_question.svg';
import ic_quotes from './svg/ic_quotes.svg';
import ic_recycle from './svg/ic_recycle.svg';
import ic_refresh from './svg/ic_refresh.svg';
import ic_research from './svg/ic_research.svg';
import ic_research_filled from './svg/ic_research_filled.svg';
import ic_restaurant from './svg/ic_restaurant.svg';
import ic_restaurant_filled from './svg/ic_restaurant_filled.svg';
import ic_rewind from './svg/ic_rewind.svg';
import ic_rewind_filled from './svg/ic_rewind_filled.svg';
import ic_right_arrow from './svg/ic_right_arrow.svg';
import ic_route from './svg/ic_route.svg';
import ic_sale_tag from './svg/ic_sale_tag.svg';
import ic_sale_tag_filled from './svg/ic_sale_tag_filled.svg';
import ic_savings from './svg/ic_savings.svg';
import ic_savings_filled from './svg/ic_savings_filled.svg';
import ic_search from './svg/ic_search.svg';
import ic_search_filled from './svg/ic_search_filled.svg';
import ic_send from './svg/ic_send.svg';
import ic_send_filled from './svg/ic_send_filled.svg';
import ic_settings from './svg/ic_settings.svg';
import ic_share from './svg/ic_share.svg';
import ic_shield from './svg/ic_shield.svg';
import ic_shield_filled from './svg/ic_shield_filled.svg';
import ic_shirt from './svg/ic_shirt.svg';
import ic_shirt_filled from './svg/ic_shirt_filled.svg';
import ic_sidebar from './svg/ic_sidebar.svg';
import ic_sidebar_filled from './svg/ic_sidebar_filled.svg';
import ic_signal_full from './svg/ic_signal_full.svg';
import ic_signal_none from './svg/ic_signal_none.svg';
import ic_sink from './svg/ic_sink.svg';
import ic_sink_filled from './svg/ic_sink_filled.svg';
import ic_smartphone_check from './svg/ic_smartphone_check.svg';
import ic_smartphone_download from './svg/ic_smartphone_download.svg';
import ic_smile from './svg/ic_smile.svg';
import ic_smile_sad from './svg/ic_smile_sad.svg';
import ic_smiley from './svg/ic_smiley.svg';
import ic_sort from './svg/ic_sort.svg';
import ic_sparkle from './svg/ic_sparkle.svg';
import ic_stack from './svg/ic_stack.svg';
import ic_stack_filled from './svg/ic_stack_filled.svg';
import ic_star from './svg/ic_star.svg';
import ic_star_filled from './svg/ic_star_filled.svg';
import ic_star_half from './svg/ic_star_half.svg';
import ic_starburst from './svg/ic_starburst.svg';
import ic_steering_wheel from './svg/ic_steering_wheel.svg';
import ic_stock_placeholder from './svg/ic_stock_placeholder.svg';
import ic_stock_placeholder_filled from './svg/ic_stock_placeholder_filled.svg';
import ic_stop from './svg/ic_stop.svg';
import ic_stop_filled from './svg/ic_stop_filled.svg';
import ic_stop_sign from './svg/ic_stop_sign.svg';
import ic_stop_sign_filled from './svg/ic_stop_sign_filled.svg';
import ic_stopwatch from './svg/ic_stopwatch.svg';
import ic_stopwatch_filled from './svg/ic_stopwatch_filled.svg';
import ic_store from './svg/ic_store.svg';
import ic_store_filled from './svg/ic_store_filled.svg';
import ic_subtract from './svg/ic_subtract.svg';
import ic_success_circle from './svg/ic_success_circle.svg';
import ic_sun from './svg/ic_sun.svg';
import ic_sun_filled from './svg/ic_sun_filled.svg';
import ic_tablet from './svg/ic_tablet.svg';
import ic_tada from './svg/ic_tada.svg';
import ic_target from './svg/ic_target.svg';
import ic_thumbs_down from './svg/ic_thumbs_down.svg';
import ic_thumbs_down_filled from './svg/ic_thumbs_down_filled.svg';
import ic_thumbs_down_selected from './svg/ic_thumbs_down_selected.svg';
import ic_thumbs_up from './svg/ic_thumbs_up.svg';
import ic_thumbs_up_filled from './svg/ic_thumbs_up_filled.svg';
import ic_thumbs_up_selected from './svg/ic_thumbs_up_selected.svg';
import ic_touch_id from './svg/ic_touch_id.svg';
import ic_train from './svg/ic_train.svg';
import ic_train_filled from './svg/ic_train_filled.svg';
import ic_trash from './svg/ic_trash.svg';
import ic_trash_filled from './svg/ic_trash_filled.svg';
import ic_triangle_down from './svg/ic_triangle_down.svg';
import ic_triangle_up from './svg/ic_triangle_up.svg';
import ic_trophy from './svg/ic_trophy.svg';
import ic_trophy_filled from './svg/ic_trophy_filled.svg';
import ic_tv from './svg/ic_tv.svg';
import ic_umbrella from './svg/ic_umbrella.svg';
import ic_umbrella_filled from './svg/ic_umbrella_filled.svg';
import ic_walk from './svg/ic_walk.svg';
import ic_wallet from './svg/ic_wallet.svg';
import ic_wallet_filled from './svg/ic_wallet_filled.svg';
import ic_warn from './svg/ic_warn.svg';
import ic_watch from './svg/ic_watch.svg';
import ic_wrench from './svg/ic_wrench.svg';
import ic_x from './svg/ic_x.svg';
import ic_x_circle from './svg/ic_x_circle.svg';
import ic_x_circle_filled from './svg/ic_x_circle_filled.svg';
import x_circle_filled from './svg/x_circle_filled.svg';

const iconComponents = {
  'ic_add': ic_add,
  'ic_add_circle': ic_add_circle,
  'ic_add_circle_filled': ic_add_circle_filled,
  'ic_add_image': ic_add_image,
  'ic_add_image_filled': ic_add_image_filled,
  'ic_add_reaction': ic_add_reaction,
  'ic_alert_triangle': ic_alert_triangle,
  'ic_alert_triangle_filled': ic_alert_triangle_filled,
  'ic_arrow_diagonal_bottom_left': ic_arrow_diagonal_bottom_left,
  'ic_arrow_diagonal_bottom_right': ic_arrow_diagonal_bottom_right,
  'ic_arrow_diagonal_top_left': ic_arrow_diagonal_top_left,
  'ic_arrow_diagonal_top_right': ic_arrow_diagonal_top_right,
  'ic_arrow_down': ic_arrow_down,
  'ic_arrow_down_left': ic_arrow_down_left,
  'ic_arrow_down_right': ic_arrow_down_right,
  'ic_arrow_left': ic_arrow_left,
  'ic_arrow_left_down': ic_arrow_left_down,
  'ic_arrow_left_up': ic_arrow_left_up,
  'ic_arrow_redo': ic_arrow_redo,
  'ic_arrow_right': ic_arrow_right,
  'ic_arrow_right_down': ic_arrow_right_down,
  'ic_arrow_right_up': ic_arrow_right_up,
  'ic_arrow_undo': ic_arrow_undo,
  'ic_arrow_up': ic_arrow_up,
  'ic_arrow_up_left': ic_arrow_up_left,
  'ic_arrow_up_right': ic_arrow_up_right,
  'ic_arrows_expand': ic_arrows_expand,
  'ic_arrows_full_screen': ic_arrows_full_screen,
  'ic_arrows_input': ic_arrows_input,
  'ic_arrows_right_left': ic_arrows_right_left,
  'ic_atm': ic_atm,
  'ic_atm_filled': ic_atm_filled,
  'ic_atm_text': ic_atm_text,
  'ic_attachment': ic_attachment,
  'ic_balloon': ic_balloon,
  'ic_balloon_filled': ic_balloon_filled,
  'ic_bank': ic_bank,
  'ic_baseball': ic_baseball,
  'ic_baseball_filled': ic_baseball_filled,
  'ic_basketball': ic_basketball,
  'ic_basketball_filled': ic_basketball_filled,
  'ic_battery_empty': ic_battery_empty,
  'ic_battery_full': ic_battery_full,
  'ic_battery_half': ic_battery_half,
  'ic_battery_high': ic_battery_high,
  'ic_battery_low': ic_battery_low,
  'ic_bear': ic_bear,
  'ic_bear_filled': ic_bear_filled,
  'ic_bell': ic_bell,
  'ic_bell_filled': ic_bell_filled,
  'ic_bike': ic_bike,
  'ic_bluetooth': ic_bluetooth,
  'ic_boat': ic_boat,
  'ic_boat_filled': ic_boat_filled,
  'ic_book': ic_book,
  'ic_book_2': ic_book_2,
  'ic_book_2_filled': ic_book_2_filled,
  'ic_book_filled': ic_book_filled,
  'ic_bookmark': ic_bookmark,
  'ic_bookmark_filled': ic_bookmark_filled,
  'ic_bull': ic_bull,
  'ic_bull_filled': ic_bull_filled,
  'ic_burger': ic_burger,
  'ic_burger_filled': ic_burger_filled,
  'ic_bus': ic_bus,
  'ic_bus_filled': ic_bus_filled,
  'ic_cake': ic_cake,
  'ic_cake_filled': ic_cake_filled,
  'ic_calendar': ic_calendar,
  'ic_calendar_check': ic_calendar_check,
  'ic_calendar_check_filled': ic_calendar_check_filled,
  'ic_calendar_filled': ic_calendar_filled,
  'ic_camera': ic_camera,
  'ic_camera_filled': ic_camera_filled,
  'ic_car': ic_car,
  'ic_car_filled': ic_car_filled,
  'ic_card': ic_card,
  'ic_card_filled': ic_card_filled,
  'ic_cart': ic_cart,
  'ic_cart_filled': ic_cart_filled,
  'ic_cash_back': ic_cash_back,
  'ic_celebrate': ic_celebrate,
  'ic_celebrate_filled': ic_celebrate_filled,
  'ic_cent_sign': ic_cent_sign,
  'ic_check': ic_check,
  'ic_check_badge': ic_check_badge,
  'ic_check_badge_filled': ic_check_badge_filled,
  'ic_check_circle': ic_check_circle,
  'ic_check_circle_filled': ic_check_circle_filled,
  'ic_check_filled': ic_check_filled,
  'ic_check_image': ic_check_image,
  'ic_check_image_filled': ic_check_image_filled,
  'ic_check_shield': ic_check_shield,
  'ic_check_shield_filled': ic_check_shield_filled,
  'ic_checklist': ic_checklist,
  'ic_chevron': ic_chevron,
  'ic_chevron_down': ic_chevron_down,
  'ic_chevron_down_circle': ic_chevron_down_circle,
  'ic_chevron_down_circle_filled': ic_chevron_down_circle_filled,
  'ic_chevron_green_left': ic_chevron_green_left,
  'ic_chevron_left': ic_chevron_left,
  'ic_chevron_left_circle': ic_chevron_left_circle,
  'ic_chevron_left_circle_filled': ic_chevron_left_circle_filled,
  'ic_chevron_right': ic_chevron_right,
  'ic_chevron_right_circle': ic_chevron_right_circle,
  'ic_chevron_right_circle_filled': ic_chevron_right_circle_filled,
  'ic_chevron_up': ic_chevron_up,
  'ic_chevron_up_circle': ic_chevron_up_circle,
  'ic_chevron_up_circle_filled': ic_chevron_up_circle_filled,
  'ic_circle_check': ic_circle_check,
  'ic_circle_check_filled': ic_circle_check_filled,
  'ic_circle_circle': ic_circle_circle,
  'ic_circle_circle_filled': ic_circle_circle_filled,
  'ic_circle_dollar': ic_circle_dollar,
  'ic_circle_dollar_filled': ic_circle_dollar_filled,
  'ic_circle_minus': ic_circle_minus,
  'ic_circle_minus_filled': ic_circle_minus_filled,
  'ic_circle_slash': ic_circle_slash,
  'ic_circle_smile': ic_circle_smile,
  'ic_circle_smile_filled': ic_circle_smile_filled,
  'ic_clock': ic_clock,
  'ic_clock_filled': ic_clock_filled,
  'ic_conversation': ic_conversation,
  'ic_conversation_filled': ic_conversation_filled,
  'ic_copy': ic_copy,
  'ic_copy_filled': ic_copy_filled,
  'ic_crash': ic_crash,
  'ic_crash_filled': ic_crash_filled,
  'ic_crown': ic_crown,
  'ic_crown_filled': ic_crown_filled,
  'ic_currency_dollar': ic_currency_dollar,
  'ic_currency_dollar_circle': ic_currency_dollar_circle,
  'ic_currency_dollar_circle_filled': ic_currency_dollar_circle_filled,
  'ic_currency_dollar_square': ic_currency_dollar_square,
  'ic_currency_dollar_square_filled': ic_currency_dollar_square_filled,
  'ic_currency_euro': ic_currency_euro,
  'ic_currency_pound': ic_currency_pound,
  'ic_currency_yen': ic_currency_yen,
  'ic_custom_card': ic_custom_card,
  'ic_custom_card_filled': ic_custom_card_filled,
  'ic_customer_service': ic_customer_service,
  'ic_debit_pin': ic_debit_pin,
  'ic_deposit_check': ic_deposit_check,
  'ic_deposit_check_filled': ic_deposit_check_filled,
  'ic_desktop': ic_desktop,
  'ic_diamond': ic_diamond,
  'ic_diamond_filled': ic_diamond_filled,
  'ic_directions': ic_directions,
  'ic_dollar_bill': ic_dollar_bill,
  'ic_dollar_bill_filled': ic_dollar_bill_filled,
  'ic_dot': ic_dot,
  'ic_download': ic_download,
  'ic_earth': ic_earth,
  'ic_ellipse': ic_ellipse,
  'ic_emergency': ic_emergency,
  'ic_emergency_filled': ic_emergency_filled,
  'ic_envelope': ic_envelope,
  'ic_envelope_filled': ic_envelope_filled,
  'ic_envelope_open': ic_envelope_open,
  'ic_envelope_open_filled': ic_envelope_open_filled,
  'ic_error_circle': ic_error_circle,
  'ic_error_circle_filled': ic_error_circle_filled,
  'ic_etf_placeholder': ic_etf_placeholder,
  'ic_external_link': ic_external_link,
  'ic_eye_hide': ic_eye_hide,
  'ic_eye_show': ic_eye_show,
  'ic_eye_show_filled': ic_eye_show_filled,
  'ic_face_id': ic_face_id,
  'ic_family': ic_family,
  'ic_family_filled': ic_family_filled,
  'ic_fast_forward': ic_fast_forward,
  'ic_fast_forward_filled': ic_fast_forward_filled,
  'ic_file': ic_file,
  'ic_file_filled': ic_file_filled,
  'ic_find_location': ic_find_location,
  'ic_find_location_filled': ic_find_location_filled,
  'ic_flag': ic_flag,
  'ic_flag_filled': ic_flag_filled,
  'ic_folder': ic_folder,
  'ic_folder_filled': ic_folder_filled,
  'ic_game_controller': ic_game_controller,
  'ic_game_controller_filled': ic_game_controller_filled,
  'ic_gaming': ic_gaming,
  'ic_gaming_filled': ic_gaming_filled,
  'ic_gas_station': ic_gas_station,
  'ic_gas_station_filled': ic_gas_station_filled,
  'ic_gift': ic_gift,
  'ic_gift_filled': ic_gift_filled,
  'ic_gl_square': ic_gl_square,
  'ic_graduation': ic_graduation,
  'ic_graduation_cap': ic_graduation_cap,
  'ic_graduation_filled': ic_graduation_filled,
  'ic_graph_bar': ic_graph_bar,
  'ic_graph_bar_filled': ic_graph_bar_filled,
  'ic_graph_pie': ic_graph_pie,
  'ic_graph_pie_filled': ic_graph_pie_filled,
  'ic_greenlight': ic_greenlight,
  'ic_grid': ic_grid,
  'ic_grid_filled': ic_grid_filled,
  'ic_hanger': ic_hanger,
  'ic_headphones': ic_headphones,
  'ic_headphones_filled': ic_headphones_filled,
  'ic_heart': ic_heart,
  'ic_heart_filled': ic_heart_filled,
  'ic_help': ic_help,
  'ic_help_circle': ic_help_circle,
  'ic_help_circle_filled': ic_help_circle_filled,
  'ic_help_square': ic_help_square,
  'ic_home': ic_home,
  'ic_home_filled': ic_home_filled,
  'ic_image': ic_image,
  'ic_image_filled': ic_image_filled,
  'ic_info_circle': ic_info_circle,
  'ic_info_circle_filled': ic_info_circle_filled,
  'ic_invest': ic_invest,
  'ic_invest_down': ic_invest_down,
  'ic_laptop': ic_laptop,
  'ic_leave': ic_leave,
  'ic_lifesaver': ic_lifesaver,
  'ic_lightbulb': ic_lightbulb,
  'ic_lightbulb_filled': ic_lightbulb_filled,
  'ic_lightning': ic_lightning,
  'ic_lightning_filled': ic_lightning_filled,
  'ic_link': ic_link,
  'ic_list': ic_list,
  'ic_loading': ic_loading,
  'ic_location': ic_location,
  'ic_location_filled': ic_location_filled,
  'ic_location_map': ic_location_map,
  'ic_location_map_filled': ic_location_map_filled,
  'ic_location_pin': ic_location_pin,
  'ic_location_pin_filled': ic_location_pin_filled,
  'ic_lock': ic_lock,
  'ic_lock_filled': ic_lock_filled,
  'ic_lock_unlocked': ic_lock_unlocked,
  'ic_lock_unlocked_filled': ic_lock_unlocked_filled,
  'ic_log_out': ic_log_out,
  'ic_logo_amazon': ic_logo_amazon,
  'ic_logo_android': ic_logo_android,
  'ic_logo_apple': ic_logo_apple,
  'ic_logo_bitcoin': ic_logo_bitcoin,
  'ic_logo_facebook': ic_logo_facebook,
  'ic_logo_google': ic_logo_google,
  'ic_logo_instagram': ic_logo_instagram,
  'ic_logo_linked_in': ic_logo_linked_in,
  'ic_logo_paypal': ic_logo_paypal,
  'ic_logo_tiktok': ic_logo_tiktok,
  'ic_logo_twitter': ic_logo_twitter,
  'ic_logo_venmo': ic_logo_venmo,
  'ic_logo_youtube': ic_logo_youtube,
  'ic_lunch': ic_lunch,
  'ic_map': ic_map,
  'ic_map_filled': ic_map_filled,
  'ic_menu': ic_menu,
  'ic_message': ic_message,
  'ic_message_alert': ic_message_alert,
  'ic_message_alert_filled': ic_message_alert_filled,
  'ic_message_filled': ic_message_filled,
  'ic_microphone': ic_microphone,
  'ic_microphone_filled': ic_microphone_filled,
  'ic_money_bag': ic_money_bag,
  'ic_money_bag_filled': ic_money_bag_filled,
  'ic_moon': ic_moon,
  'ic_moon_filled': ic_moon_filled,
  'ic_more': ic_more,
  'ic_number_0_circle': ic_number_0_circle,
  'ic_number_0_circle_filled': ic_number_0_circle_filled,
  'ic_number_0_square': ic_number_0_square,
  'ic_number_0_square_filled': ic_number_0_square_filled,
  'ic_number_1_circle': ic_number_1_circle,
  'ic_number_1_circle_filled': ic_number_1_circle_filled,
  'ic_number_1_square': ic_number_1_square,
  'ic_number_1_square_filled': ic_number_1_square_filled,
  'ic_number_2_circle': ic_number_2_circle,
  'ic_number_2_circle_filled': ic_number_2_circle_filled,
  'ic_number_2_square': ic_number_2_square,
  'ic_number_2_square_filled': ic_number_2_square_filled,
  'ic_number_3_circle': ic_number_3_circle,
  'ic_number_3_circle_filled': ic_number_3_circle_filled,
  'ic_number_3_square': ic_number_3_square,
  'ic_number_3_square_filled': ic_number_3_square_filled,
  'ic_number_4_circle': ic_number_4_circle,
  'ic_number_4_circle_filled': ic_number_4_circle_filled,
  'ic_number_4_square': ic_number_4_square,
  'ic_number_4_square_filled': ic_number_4_square_filled,
  'ic_number_5_circle': ic_number_5_circle,
  'ic_number_5_circle_filled': ic_number_5_circle_filled,
  'ic_number_5_square': ic_number_5_square,
  'ic_number_5_square_filled': ic_number_5_square_filled,
  'ic_number_6_circle': ic_number_6_circle,
  'ic_number_6_circle_filled': ic_number_6_circle_filled,
  'ic_number_6_square': ic_number_6_square,
  'ic_number_6_square_filled': ic_number_6_square_filled,
  'ic_number_7_circle': ic_number_7_circle,
  'ic_number_7_circle_filled': ic_number_7_circle_filled,
  'ic_number_7_square': ic_number_7_square,
  'ic_number_7_square_filled': ic_number_7_square_filled,
  'ic_number_8_circle': ic_number_8_circle,
  'ic_number_8_circle_filled': ic_number_8_circle_filled,
  'ic_number_8_square': ic_number_8_square,
  'ic_number_8_square_filled': ic_number_8_square_filled,
  'ic_number_9_circle': ic_number_9_circle,
  'ic_number_9_circle_filled': ic_number_9_circle_filled,
  'ic_number_9_square': ic_number_9_square,
  'ic_number_9_square_filled': ic_number_9_square_filled,
  'ic_number_one_circle_filled': ic_number_one_circle_filled,
  'ic_number_one_square': ic_number_one_square,
  'ic_number_two_circle_filled': ic_number_two_circle_filled,
  'ic_number_two_square': ic_number_two_square,
  'ic_odometer': ic_odometer,
  'ic_odometer_filled': ic_odometer_filled,
  'ic_options': ic_options,
  'ic_options_filled': ic_options_filled,
  'ic_pace': ic_pace,
  'ic_parent': ic_parent,
  'ic_parent_filled': ic_parent_filled,
  'ic_passenger': ic_passenger,
  'ic_pause': ic_pause,
  'ic_pause_filled': ic_pause_filled,
  'ic_paw': ic_paw,
  'ic_paw_filled': ic_paw_filled,
  'ic_pen': ic_pen,
  'ic_people': ic_people,
  'ic_people_filled': ic_people_filled,
  'ic_person': ic_person,
  'ic_person_add': ic_person_add,
  'ic_person_add_filled': ic_person_add_filled,
  'ic_person_check': ic_person_check,
  'ic_person_check_filled': ic_person_check_filled,
  'ic_person_filled': ic_person_filled,
  'ic_phone': ic_phone,
  'ic_phone_filled': ic_phone_filled,
  'ic_phone_mobile': ic_phone_mobile,
  'ic_piggy_bank': ic_piggy_bank,
  'ic_piggy_bank_filled': ic_piggy_bank_filled,
  'ic_plane': ic_plane,
  'ic_plane_filled': ic_plane_filled,
  'ic_play': ic_play,
  'ic_play_circle': ic_play_circle,
  'ic_play_circle_filled': ic_play_circle_filled,
  'ic_play_filled': ic_play_filled,
  'ic_plus': ic_plus,
  'ic_profile_circle': ic_profile_circle,
  'ic_profile_circle_filled': ic_profile_circle_filled,
  'ic_push_pin': ic_push_pin,
  'ic_push_pin_filled': ic_push_pin_filled,
  'ic_qr_code': ic_qr_code,
  'ic_question': ic_question,
  'ic_quotes': ic_quotes,
  'ic_recycle': ic_recycle,
  'ic_refresh': ic_refresh,
  'ic_research': ic_research,
  'ic_research_filled': ic_research_filled,
  'ic_restaurant': ic_restaurant,
  'ic_restaurant_filled': ic_restaurant_filled,
  'ic_rewind': ic_rewind,
  'ic_rewind_filled': ic_rewind_filled,
  'ic_right_arrow': ic_right_arrow,
  'ic_route': ic_route,
  'ic_sale_tag': ic_sale_tag,
  'ic_sale_tag_filled': ic_sale_tag_filled,
  'ic_savings': ic_savings,
  'ic_savings_filled': ic_savings_filled,
  'ic_search': ic_search,
  'ic_search_filled': ic_search_filled,
  'ic_send': ic_send,
  'ic_send_filled': ic_send_filled,
  'ic_settings': ic_settings,
  'ic_share': ic_share,
  'ic_shield': ic_shield,
  'ic_shield_filled': ic_shield_filled,
  'ic_shirt': ic_shirt,
  'ic_shirt_filled': ic_shirt_filled,
  'ic_sidebar': ic_sidebar,
  'ic_sidebar_filled': ic_sidebar_filled,
  'ic_signal_full': ic_signal_full,
  'ic_signal_none': ic_signal_none,
  'ic_sink': ic_sink,
  'ic_sink_filled': ic_sink_filled,
  'ic_smartphone_check': ic_smartphone_check,
  'ic_smartphone_download': ic_smartphone_download,
  'ic_smile': ic_smile,
  'ic_smile_sad': ic_smile_sad,
  'ic_smiley': ic_smiley,
  'ic_sort': ic_sort,
  'ic_sparkle': ic_sparkle,
  'ic_stack': ic_stack,
  'ic_stack_filled': ic_stack_filled,
  'ic_star': ic_star,
  'ic_star_filled': ic_star_filled,
  'ic_star_half': ic_star_half,
  'ic_starburst': ic_starburst,
  'ic_steering_wheel': ic_steering_wheel,
  'ic_stock_placeholder': ic_stock_placeholder,
  'ic_stock_placeholder_filled': ic_stock_placeholder_filled,
  'ic_stop': ic_stop,
  'ic_stop_filled': ic_stop_filled,
  'ic_stop_sign': ic_stop_sign,
  'ic_stop_sign_filled': ic_stop_sign_filled,
  'ic_stopwatch': ic_stopwatch,
  'ic_stopwatch_filled': ic_stopwatch_filled,
  'ic_store': ic_store,
  'ic_store_filled': ic_store_filled,
  'ic_subtract': ic_subtract,
  'ic_success_circle': ic_success_circle,
  'ic_sun': ic_sun,
  'ic_sun_filled': ic_sun_filled,
  'ic_tablet': ic_tablet,
  'ic_tada': ic_tada,
  'ic_target': ic_target,
  'ic_thumbs_down': ic_thumbs_down,
  'ic_thumbs_down_filled': ic_thumbs_down_filled,
  'ic_thumbs_down_selected': ic_thumbs_down_selected,
  'ic_thumbs_up': ic_thumbs_up,
  'ic_thumbs_up_filled': ic_thumbs_up_filled,
  'ic_thumbs_up_selected': ic_thumbs_up_selected,
  'ic_touch_id': ic_touch_id,
  'ic_train': ic_train,
  'ic_train_filled': ic_train_filled,
  'ic_trash': ic_trash,
  'ic_trash_filled': ic_trash_filled,
  'ic_triangle_down': ic_triangle_down,
  'ic_triangle_up': ic_triangle_up,
  'ic_trophy': ic_trophy,
  'ic_trophy_filled': ic_trophy_filled,
  'ic_tv': ic_tv,
  'ic_umbrella': ic_umbrella,
  'ic_umbrella_filled': ic_umbrella_filled,
  'ic_walk': ic_walk,
  'ic_wallet': ic_wallet,
  'ic_wallet_filled': ic_wallet_filled,
  'ic_warn': ic_warn,
  'ic_watch': ic_watch,
  'ic_wrench': ic_wrench,
  'ic_x': ic_x,
  'ic_x_circle': ic_x_circle,
  'ic_x_circle_filled': ic_x_circle_filled,
  'x_circle_filled': x_circle_filled
};

export const iconMap = iconComponents;
export type IconName = keyof typeof iconMap;
